export default "__VITE_ASSET__VLpYXF3h__"